module.exports = __webpack_public_path__ + "media/images/convenios/camara_farmacia-7b11ddcde8244fa4224763779bf8b081.jpg";